"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Conversion of {@link OptimizationGraphData}.
 * @author Radek Beran
 */


var OptimizationGraphDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimizationGraphDataConverter, _DataObjectConverter_);

  function OptimizationGraphDataConverter() {
    _classCallCheck(this, OptimizationGraphDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraphDataConverter).apply(this, arguments));
  }

  return OptimizationGraphDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimizationGraphDataConverter = OptimizationGraphDataConverter;